import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { FC } from 'react';

import { Projekt } from '../../api/projekt.types';
import { useProjektAutoCompleteOptionsQuery } from '../../api/projektApi';

interface ProjektAutocompleteProps {
  label: string;
  value?: string | null;
  onChange: (projektId: string | null) => void;
  error?: string;
  required?: boolean;
}

export const ProjektAutocomplete: FC<ProjektAutocompleteProps> = ({
  value,
  onChange,
  label,
  error,
  required,
}) => {
  const { data, isFetching: isFetchingList } = useProjektAutoCompleteOptionsQuery();

  const projekte = data ?? [];

  return (
    <Autocomplete
      value={projekte.find(k => k.id === value) ?? null}
      renderInput={params => (
        <TextField
          onClick={e => {
            e.stopPropagation();
          }}
          {...params}
          label={label}
          variant="outlined"
          error={Boolean(error)}
          helperText={error}
          required={required}
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              endAdornment: (
                <>
                  {isFetchingList && <CircularProgress color="inherit" size={20} />}
                  {params.slotProps.input.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
      options={projekte}
      getOptionLabel={o => `${o.kunde.organisation} - ${o.name}`}
      onChange={(_, value) => {
        const projekt: Projekt | null = value;
        if (projekt) {
          /* setSelectedProjektId(projekt.id);*/
          onChange(projekt.id);
        } else {
          /*setSelectedProjektId(null);*/
          onChange(null);
        }
      }}
      noOptionsText="Nicht gefunden"
    />
  );
};
